import PhotoPositionIndicator from '../src/PhotoPositionIndicator';
export default PhotoPositionIndicator;
